import { render, staticRenderFns } from "./MatterCriminalComplaintForm.vue?vue&type=template&id=6eec0335&"
import script from "./MatterCriminalComplaintForm.vue?vue&type=script&lang=js&"
export * from "./MatterCriminalComplaintForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterCriminalComplaintForm.vue?vue&type=style&index=0&id=6eec0335&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports